var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreDotsWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_969_10630",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 8H8V28H28V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_969_10630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0026 16.332C12.0859 16.332 11.3359 17.082 11.3359 17.9987C11.3359 18.9154 12.0859 19.6654 13.0026 19.6654C13.9193 19.6654 14.6693 18.9154 14.6693 17.9987C14.6693 17.082 13.9193 16.332 13.0026 16.332ZM23.0026 16.332C22.0859 16.332 21.3359 17.082 21.3359 17.9987C21.3359 18.9154 22.0859 19.6654 23.0026 19.6654C23.9193 19.6654 24.6693 18.9154 24.6693 17.9987C24.6693 17.082 23.9193 16.332 23.0026 16.332ZM18.0026 16.332C17.0859 16.332 16.3359 17.082 16.3359 17.9987C16.3359 18.9154 17.0859 19.6654 18.0026 19.6654C18.9193 19.6654 19.6693 18.9154 19.6693 17.9987C19.6693 17.082 18.9193 16.332 18.0026 16.332Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreDotsWhite);
export default __webpack_public_path__ + "static/media/more-dots-white.8b625bb236641e8967f634ce2f028eb7.svg";
export { ForwardRef as ReactComponent };